import ModalMsg from "../../components/ModalMsg";
import React, {Fragment} from "react";
import Translate from "../../components/Translate";
import NsField from "../../components/fields/NsField";
import Card from "../../components/card/Card";
import {Form, Formik} from "formik";
import {Divider} from "primereact/divider";

export default function ResetPasswordView({
                                              show,
                                              modalMsg,
                                              formikRef,
                                              onCloseModal,
                                              initialValuesForm,
                                              onSubmitForm,
                                              getPasswordFooter,
                                              getConfirmPasswordFooter,
                                              passwordOk,
                                              password2Ok,
                                              onChangePassword,
                                              onChangeConfirmPassword,
                                          }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={onCloseModal}
                testo={modalMsg}/>
            <Card
                icon={'fas fa-key'}
                title={'Reimposta password'}
                subtitle={'Inserisci una nuova password'}
            >
                <div className="ns-login ns-recupera-pwd">
                    <Formik
                        initialValues={initialValuesForm}
                        innerRef={formikRef}
                        onSubmit={onSubmitForm}
                    >
                        {({values, errors, touched, submitCount}) => (
                            <Form className="row g-3">
                                <div className="col-md-12">
                                    <NsField
                                        name={"password"}
                                        label={"Password*:"}
                                        as={"password"}
                                        isRequired={true}
                                        formikRef={formikRef}
                                        onChange={onChangePassword}
                                        passwordShowFeedback={true}
                                        passwordFooter={getPasswordFooter}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <NsField
                                        name={"password2"}
                                        label={"Conferma password*:"}
                                        as={"password"}
                                        isRequired={true}
                                        formikRef={formikRef}
                                        onChange={onChangeConfirmPassword}
                                        passwordShowFeedback={true}
                                        passwordFooter={getConfirmPasswordFooter}
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        submitCount={submitCount}
                                    />
                                </div>
                                <div className="d-grid gap-2">
                                    <button type="submit" name="conferma" id="conferma"
                                            className="btn btn-dark"
                                            disabled={values["password"] === '' || values["password2"] === '' || values["password"] !== values["password2"] || !passwordOk || !password2Ok}>
                                        <i className="fas fa-check"/> <Translate>Salva</Translate>
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Card>
        </div>
    )
}
